import { Navigate, Route, Routes } from "react-router-dom";

import { SIGNED_OUT_PATH } from "./auth/SessionProvider";
import { AppShell } from "./components/layout/AppShell";
import { AccountPage } from "./pages/AccountPage";
import { AdminPage } from "./pages/AdminPage";
import { CpuPage } from "./pages/CpuPage";
import { CpuRunPage } from "./pages/CpuRunPage";
import { CpuWorkspacePage } from "./pages/CpuWorkspacePage";
import { DocsLayout } from "./components/docs/DocsLayout";
import { DocsIndexPage } from "./pages/DocsIndexPage";
import { DocsSectionPage } from "./pages/DocsSectionPage";
import { EnvironmentsPage } from "./pages/EnvironmentsPage";
import { HomePage } from "./pages/HomePage";
import { JobDetailPage } from "./pages/JobDetailPage";
import { JobsPage } from "./pages/JobsPage";
import { NewWorkspacePage } from "./pages/NewWorkspacePage";
import { RelayPage } from "./pages/RelayPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { WorkspacePage } from "./pages/WorkspacePage";

/** Route table: workspaces first, jobs second, your key where you can find it. */
export function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/new" element={<NewWorkspacePage />} />
        <Route path="/workspaces/:id" element={<WorkspacePage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:id" element={<JobDetailPage />} />
        {/* The other fleet: a machine with cores and a shell, or a command on
            cores. Neither is a workspace with no GPU, and they keep separate
            paths because they are separate kinds. */}
        <Route path="/cpu" element={<CpuPage />} />
        <Route path="/cpu/:id" element={<CpuRunPage />} />
        <Route path="/cpu-workspaces/:id" element={<CpuWorkspacePage />} />
        {/* Pick an environment, or save your own under a name you chose. */}
        <Route path="/environments" element={<EnvironmentsPage />} />
        {/* Reaching our MLflow from a run that happens somewhere else, and —
            for the people the team has declared to IDRIS — the door to Jean
            Zay. Every approved researcher has it; nothing here refuses. */}
        <Route path="/relay" element={<RelayPage />} />
        {/* Two backend messages send researchers here when their key is
            missing or wrong; it has to exist and be reachable from the menu. */}
        <Route path="/account" element={<AccountPage />} />
        {/* Approving people, stopping runaway work, pausing everything. */}
        <Route path="/admin" element={<AdminPage />} />
        {/* Where a failed sign-in lands. Reaching it *with* a session means
            the session was repaired in the meantime — go to the console. */}
        <Route path={SIGNED_OUT_PATH} element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      {/* The manual: behind the same sign-in, outside the console shell —
          a documentation space of its own, one section per page. An unknown
          section redirects to the index rather than to a dead end. */}
      <Route path="/docs" element={<DocsLayout />}>
        <Route index element={<DocsIndexPage />} />
        <Route path=":sectionId" element={<DocsSectionPage />} />
      </Route>
    </Routes>
  );
}
